import type { ArticleCategory } from "@acme/db/schema";
import { ARTICLE_CATEGORIES } from "@acme/db/schema";
import * as m from "~/paraglide/messages.js";

/**
 * The one subject an article is filed under.
 *
 * A closed set, unlike `tags`: it is the chip on a card and it is the filter on
 * the listing, and both need a fixed vocabulary that translates. The stored
 * value is the stable key; only the label moves between locales.
 */
const CATEGORY_LABELS: Record<ArticleCategory, () => string> = {
  "getting-started": m.blog_category_getting_started,
  operations: m.blog_category_operations,
  "system-design": m.blog_category_system_design,
};

export interface BlogCategory {
  label: string;
  value: ArticleCategory;
}

export function getBlogCategories(): BlogCategory[] {
  return ARTICLE_CATEGORIES.map((value) => ({
    label: categoryLabel(value),
    value,
  }));
}

export function categoryLabel(category: ArticleCategory): string {
  return CATEGORY_LABELS[category]();
}
